/*
 *
 * Settlements constants
 *
 */

import { STANDARD, VENDOR, INSTANT } from 'utils/constants';

export const BASE_ACTION_CONSTANT = 'app/Settlements';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const UPDATE_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_TABLE_DATA`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const SEARCH_SETTLEMENTS = `${BASE_ACTION_CONSTANT}/SEARCH_SETTLEMENTS`;

export const SEARCH_SETTLEMENTS_IMPORT = `${BASE_ACTION_CONSTANT}/SEARCH_SETTLEMENTS_IMPORT`;

export const SAVE_SETTLEMENTS = `${BASE_ACTION_CONSTANT}/SAVE_SETTLEMENTS`;

export const SAVE_IMPORT_SETTLEMENTS = `${BASE_ACTION_CONSTANT}/SAVE_IMPORT_SETTLEMENTS`;

export const GENERATE_SETTLEMENT_REPORT = `${BASE_ACTION_CONSTANT}/GENERATE_SETTLEMENT_REPORT`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const GET_SETTLEMENT_HOLIDAYS = `${BASE_ACTION_CONSTANT}/GET_SETTLEMENT_HOLIDAYS`;

export const UPDATE_SETTLEMENT_HOLIDAYS = `${BASE_ACTION_CONSTANT}/UPDATE_SETTLEMENT_HOLIDAYS`;

export const GET_UNSETTLED_AMOUNT = `${BASE_ACTION_CONSTANT}/GET_UNSETTLED_AMOUNT`;

export const UPDATE_UNSETTLED_AMOUNT = `${BASE_ACTION_CONSTANT}/UPDATE_UNSETTLED_AMOUNT`;

export const GET_SETTLEMENT_RATES = `${BASE_ACTION_CONSTANT}/GET_SETTLEMENT_RATES`;

export const GET_UNIFICATION_ONBOARDING = `${BASE_ACTION_CONSTANT}/GET_UNIFICATION_ONBOARDING`;

export const GET_INSTANT_SETTLEMENTS_ELIGIBILITY = `${BASE_ACTION_CONSTANT}/GET_INSTANT_SETTLEMENTS_ELIGIBILITY`;

export const REQUEST_INSTANT_SETTLEMENTS_ONBOARDING = `${BASE_ACTION_CONSTANT}/REQUEST_INSTANT_SETTLEMENTS_ONBOARDING`;

export const GET_INSTANT_SETTLEMENTS_RATES_AND_LIMITS = `${BASE_ACTION_CONSTANT}/GET_INSTANT_SETTLEMENTS_RATES_AND_LIMITS`;

export const GET_INSTANT_SETTLEMENTS_MAX_DAILY_LIMIT = `${BASE_ACTION_CONSTANT}/GET_INSTANT_SETTLEMENTS_MAX_DAILY_LIMIT`;

export const GET_ON_DEMAND_SETTLEMENT_STATUS = `${BASE_ACTION_CONSTANT}/GET_ON_DEMAND_SETTLEMENT_STATUS`;

export const GET_SETTLEMENT_TIMELINE = `${BASE_ACTION_CONSTANT}/GET_SETTLEMENT_TIMELINE`;

export const SAVE_LIVE_SETTLEMENT = `${BASE_ACTION_CONSTANT}/SAVE_LIVE_SETTLEMENT`;

export const FETCH_LIVE_SETTLEMENT = `${BASE_ACTION_CONSTANT}/FETCH_LIVE_SETTLEMENT`;

export const SET_SETTLEMENT_DETAILS_DATA = `${BASE_ACTION_CONSTANT}/SET_SETTLEMENT_DETAILS_DATA`;

export const RESET_SETTLEMENT_DETAILS_DATA = `${BASE_ACTION_CONSTANT}/RESET_SETTLEMENT_DETAILS_DATA`;

export const SET_SETTLEMENT_TYPE_DATA = `${BASE_ACTION_CONSTANT}/SET_SETTLEMENT_TYPE_DATA`;

export const GET_NEXT_SETTLEMENTS_DETAILS = `${BASE_ACTION_CONSTANT}/GET_NEXT_SETTLEMENTS_DETAILS`;
export const SAVE_NEXT_SETTLEMENTS_DETAILS = `${BASE_ACTION_CONSTANT}/SAVE_NEXT_SETTLEMENTS_DETAILS`;

export const NOT_REQUESTED = 'NOT_REQUESTED';

export const ACTIVE = 'ACTIVE';

export const IN_PROGRESS = 'IN_PROGRESS';

export const IN_REVIEW = 'IN_REVIEW';

export const CREATED = 'CREATED';

export const STANDARD_INSANT_MERGED_HEADINGS = [
  {
    key: 'settlementTypeCTA',
    displayName: '',
    width: 0.04,
  },
  {
    key: 'addedOn',
    displayName: 'Initiated At',
    tooltip: 'Initiated At',
    width: 0.08,
  },
  {
    key: 'period',
    displayName: 'Period',
    width: 0.14,
  },
  {
    key: 'utr',
    displayName: 'UTR No.',
    width: 0.1,
  },
  {
    key: 'transactionAmount',
    displayName: 'Txn. Amt.',
    width: 0.09,
    align: 'right',
  },
  {
    key: 'adjustment',
    displayName: 'Adjustment Amt.',
    tooltip: 'Adjustment Amt.',
    width: 0.1,
    align: 'right',
  },
  {
    key: 'charges',
    displayName: 'Txn. Charges',
    tooltip: 'Txn. Charges',
    width: 0.09,
    align: 'right',
  },
  {
    key: 'settlementCharge',
    displayName: 'Settlement Charges',
    tooltip: 'Settlement Charges',
    width: 0.1,
    align: 'right',
  },
  {
    key: 'settledAmount',
    displayName: 'Settled Amt.',
    width: 0.1,
    align: 'right',
  },
  {
    key: 'settlementStatus',
    displayName: 'Status',
    width: 0.08,
  },
  {
    key: 'settlementLinkCTA',
    displayName: '',
    width: 0.04,
  },
  // [1.5, 1.5, 1.2, 1.4, 1.5, 1, 1.5, 1.2, 0.6],
];

export const HEADINGS = {
  [STANDARD]: [
    {
      key: 'settlementTypeCTA',
      displayName: '',
      width: 0.04,
    },
    {
      key: 'addedOn',
      displayName: 'Initiated At',
      tooltip: 'Initiated At',
      width: 0.1,
    },
    {
      key: 'period',
      displayName: 'Transaction Period',
      width: 0.14,
    },
    {
      key: 'utr',
      displayName: 'UTR',
      width: 0.8,
    },
    {
      key: 'settledAmount',
      displayName: 'Settled Amt.',
      width: 0.8,
    },
    {
      key: 'settlementStatus',
      displayName: 'Status',
      width: 2,
    },
    // [1.5, 1.5, 1.2, 1.4, 1.5, 1, 1.5, 1.2, 0.6],
  ],
  [INSTANT]: [
    {
      key: 'addedOn',
      displayName: 'Date & Time',
      width: 0.15,
    },
    {
      key: 'settlementId',
      displayName: 'Settlement ID',
      width: 0.15,
    },
    {
      key: 'transactionAmount',
      displayName: 'Txn. Amt.',
      width: 0.15,
      align: 'right',
    },
    {
      key: 'adjustment',
      displayName: 'Adjustment Amt.',
      width: 0.15,
      align: 'right',
    },
    {
      key: 'charges',
      displayName: 'Charges',
      width: 0.1,
      align: 'right',
    },
    {
      key: 'settledAmount',
      displayName: 'Settled Amt.',
      width: 0.1,
      align: 'right',
    },
    {
      key: 'settlementStatus',
      displayName: 'Status',
      width: 0.1,
    },
    {
      key: 'settlementLinkCTA',
      displayName: '',
      width: 0.05,
    },
  ],
  [VENDOR]: [
    {
      key: 'addedOn',
      displayName: 'Date & Time',
      width: 0.15,
    },
    {
      key: 'period',
      displayName: 'Period',
      width: 0.11,
    },
    {
      key: 'settlementType',
      displayName: 'Type',
      width: 0.08,
    },
    {
      key: 'merchantVendorId',
      displayName: 'Vendor ID',
      width: 0.12,
    },
    {
      key: 'payoutId',
      displayName: 'Settlement ID',
      width: 0.12,
    },
    {
      key: 'utr',
      displayName: 'UTR No.',
      width: 0.12,
    },
    {
      key: 'adjustmentAmount',
      displayName: 'Adjustment Amt.',
      width: 0.14,
      align: 'right',
    },
    {
      key: 'settledAmount',
      displayName: 'Settled Amt.',
      width: 0.12,
      align: 'right',
    },
    {
      key: 'status',
      displayName: 'Status',
      width: 0.12,
    },
    {
      key: 'failureReason',
      displayName: 'Failure Reason',
      width: 0.13,
    },
    {
      key: 'settlementLinkCTA',
      displayName: '',
      width: 0.06,
    },
  ],
  VENDOR_FOR_SETTLEMENT_V2_UI: [
    {
      key: 'settlementTypeCTA',
      displayName: '',
      width: 0.04,
    },
    {
      key: 'addedOn',
      displayName: 'Initiated At',
      tooltip: 'Initiated At',
      width: 0.14,
    },
    {
      key: 'payoutId',
      displayName: 'Vendor ID',
      tooltip: 'Vendor ID',
      width: 0.1,
    },
    {
      key: 'period',
      displayName: 'Payment Range',
      width: 0.18,
    },
    {
      key: 'utr',
      displayName: 'UTR',
      width: 0.14,
    },
    {
      key: 'settledAmount',
      displayName: 'Settled Amt.',
      width: 0.1,
    },
    {
      key: 'settlementStatus',
      displayName: 'Status',
      width: 0.3,
    },
  ],
};

export const SEARCH_SETTLEMENTS_STANDARD_URL = {
  url: '/pg/settlements/merchant-payments/search',
  method: 'GET',
};

export const SEARCH_SETTLEMENTS_TIMELINE_URL = {
  url: '/pg/settlements/merchant-settlement/search',
  method: 'GET',
};
export const SEARCH_VENDOR_SETTLEMENTS_TIMELINE_URL = {
  url: '/pg/settlements/split/vendor-settlement/search',
  method: 'GET',
};

export const SEARCH_SETTLEMENTS_INSTANT_URL = {
  url: '/pg/settlements/instant/search',
  method: 'GET',
};

export const GENERATE_VENDOR_SETTLEMENTS_REPORTS_URL = {
  url: '/common/report/vendor-settlement/$payment_id$',
  method: 'GET',
};

export const GENERATE_VENDOR_SETTLEMENTS_REPORTS_URL_V2 = {
  url: '/pg/report/vendor-settlement/$payment_id$',
  method: 'GET',
};

export const GET_ON_DEMAND_SETTLEMENT_STATUS_URL = {
  url: '/pg/ondemand/status',
  method: 'GET',
};

export const GET_SETTLEMENT_RATES_URL = {
  url: '/pg/settlements/instant/rates',
  method: 'GET',
};

export const REQUEST_INSTANT_SETTLEMENTS_ONBOARDING_URL = {
  url: '/pg/settlements/instant/onboarding-registration',
  method: 'POST',
};

export const GET_NEXT_SETTLEMENTS_DETAILS_URL = {
  url: '/pg/next-settlement-details',
  method: 'GET',
};

export const GET_OFFLINE_NEXT_SETTLEMENTS_DETAILS_URL = {
  url: '/op/next-settlement-details',
  method: 'GET',
};

export const GENERATE_REPORT = 'GENERATE_REPORT';

export const UNSETTLED_AMOUNT = 'UNSETTLED_AMOUNT';

export const ON_DEMAND_LIMIT = 'ON_DEMAND_LIMIT';

export const INSTANT_SETTLEMENT = 'INSTANT_SETTLEMENT';

export const KNOW_MORE_URL =
  'https://www.cashfree.com/docs/payments/split/vendor/dashboard/settlements#on-demand-settlement';

export const AUTOMATED = 'AUTOMATED';
export const MANUAL = 'MANUAL';

export const REPORT_TYPE_MAPPER = {
  [VENDOR]: 'vendorRecon',
  Scheduled: 'vendorRecon',
  [STANDARD]: 'settlement',
};

export const GET_INSTANT_SETTLEMENTS_ELIGIBILITY_URL = {
  url: '/pg/settlements/instant/onboarding-eligible',
  method: 'GET',
};

export const INSTANT_SETTLEMENTS_ELIGIBILITY_STATUS = {
  ELIGIBLE: 'ELIGIBLE',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
};

export const GET_INSTANT_SETTLEMENTS_MAX_DAILY_LIMIT_URL = {
  url: '/pg/settlements/instant/limits',
  method: 'GET',
};

export const GET_INSTANT_SETTLEMENTS_RATES_AND_LIMITS_URL = {
  url: '/pg/settlements/instant/onboarding-details',
  method: 'GET',
};

export const INSTANT_SETTLEMENTS_REGISTRATION_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  IN_REVIEW: 'IN_REVIEW',
  RISK_REJECTED: 'RISK_REJECTED',
  REJECTED: 'REJECTED',
  RISK_APPROVED: 'RISK_APPROVED',
  ACTIVE: 'ACTIVE',
};

export const WORKING_DAYS_ONLY = 'WORKING_DAYS_ONLY';

export const ALL_DAYS = 'ALL_DAYS';

export const SAME_DAY_SETTLEMENT = 'Same day settlement';

export const AVAILABLE_ON_MAPPING = {
  WORKING_DAYS_ONLY: 'Working Days',
  ALL_DAYS: 'All days',
};

export const BREAKDOWN_EVENT = {
  PG_TAXES_CHARGES: 'PG (Charges+Taxes)',
  SETTLEMENT_TAXES_CHARGES: 'Settlement (Charges+Taxes)',
  SPLIT_TAXES_CHARGES: 'Split (Charges+Taxes)',
};

export const BREAKDOWN_EVENT_FOR_CHARGES = {
  PG_TAXES_CHARGES: 'PG',
  SETTLEMENT_TAXES_CHARGES: 'Settlement',
  SPLIT_TAXES_CHARGES: 'Split',
};

export const SETTLEMENT_BREAKDOWN_HEADING = [
  {
    displayName: 'Event',
    width: '2.42',
    key: 'e',
    align: 'left',
  },
  {
    displayName: 'Event Type',
    width: '1.12',
    key: 'et',
    align: 'left',
  },
  {
    displayName: 'Amount',
    width: '1.36',
    key: 'a',
    align: 'right',
  },
];

export const OTHER_ADJUSTMENT_HEADINGS = [
  {
    displayName: 'Event',
    width: '1.13',
    align: 'left',
  },
  {
    displayName: 'Amount',
    width: '0.91',
    align: 'center',
  },
  {
    displayName: 'Remarks',
    width: '1.56',
    align: 'left',
  },
];

export const SETTLEMENT_CHARGES_HEADING = [
  {
    displayName: 'Event',
    width: '2.42',
    key: 'e',
    align: 'left',
  },
  {
    displayName: 'Billed To',
    width: '1.12',
    key: 'et',
    align: 'center',
  },
  {
    displayName: 'Amount',
    width: '1.36',
    key: 'a',
    align: 'right',
  },
];

export const VENDOR_SETTLEMENT_STATUS_TYPES = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  REVERSED: 'REVERSED',
  CREATED: 'CREATED',
};
export const SETTLEMENT_STATUS_TYPES = {
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
};

export const SETTLEMENT_REPORT_TYPES = {
  NEW_RECON_REPORT: 'settlement_recon_v2',
  OLD_RECON_REPORT: 'settlement',
};

export const SETTLEMENT_REPORT_OPTIONS = [
  {
    key: SETTLEMENT_REPORT_TYPES.NEW_RECON_REPORT,
    value: 'New Settlements Recon',
    description:
      'We have come up with a new detailed view of your settlements.',
  },
  {
    key: SETTLEMENT_REPORT_TYPES.OLD_RECON_REPORT,
    value: 'Old Settlements Recon',
    description:
      'This is the old format which you were using earlier. We will get away with this format soon. We suggest you to download version 1.',
  },
];

export const SETTLEMENT_TIMELINE_TRANSFER_STATE = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  INITIATED_BY_BANK: 'INITIATED_BY_BANK',
  RETRY_3: 'ATTEMPT_3',
  RETRY_2: 'ATTEMPT_2',
  RETRY_1: 'ATTEMPT_1',
  INITIATED_BY_CASHFREE: 'INITIATED_BY_CASHFREE',
};

export const SETTLEMENT_TIMELINE = {
  YOUR_BANK: {
    label: 'Your Bank',
    largeLabel: 'Your Bank Account',
  },
  INITIATED_BY_BANK: {
    label: 'Partner Bank',
    largeLabel: 'Initiated by Partner Bank',
  },
  INITIATED_BY_CASHFREE: {
    label: 'Cashfree',
    largeLabel: 'Initiated by Cashfree Payments',
  },
  RETRY: {
    type: 'trial',
  },
};

export const OFFLINE_SETTLEMENT_REPORT_OPTIONS = [
  {
    key: 'offline_settlement_recon',
    value: 'New Settlements Recon',
    description:
      'We have come up with a new detailed view of your settlements.',
  },
];

export const SETTLEMENTS_TYPES = ['online', 'offline'];

export const IMPORT_SETTLEMENTS_STATUS = {
  NOT_INITIATED: 'In Progress',
  INITIATED: 'In Progress',
  PENDING: 'In Progress',
  SETTLED: 'Processed',
  SKIPPED: 'Skipped',
  REVERSED: 'Failed',
};

export const DISABLED_ICON_COLOR = '#D5D5D9';
